import { openDialog } from 'vue3-promise-dialog'
import RefreshSessionDialog from './RefreshSessionDialog.vue'
import PDFPreviewerDialog from './PDFPreviewerDialog.vue'
import RegenerateReportDialog from './RegenerateReportDialog.vue'
import ClientUploadsDialog from './ClientUploadsDialog.vue'
import AnnualQuestionnairePreviewDialog from './AnnualQuestionnairePeviewDialog.vue'
import AnnualQuestionnaireDialog from './AnnualQuestionnaireDialog.vue'

export const confirmRefreshSession = async (seconds) => {
  return await openDialog(RefreshSessionDialog, { seconds })
}

export const openPDFPreviewer = async (pdfData, fileName) => {
  return await openDialog(PDFPreviewerDialog, { pdfData, fileName })
}

export const confirmRegenerateReport = async () => {
  return await openDialog(RegenerateReportDialog, {})
}

export const openClientUploadsDialog = async () => {
  return await openDialog(ClientUploadsDialog, {})
}

export const openAnnualQuestionnairePreviewDialog = async (rawData) => {
  return await openDialog(AnnualQuestionnairePreviewDialog, { rawData })
}

export const openAnnualQuestionnaireDialog = async (rawQuestionnaireData) => {
  return await openDialog(AnnualQuestionnaireDialog, { rawQuestionnaireData })
}
